import { ADD_CYCLE, ADD_TEAM_MEMBERS, COPY, DELETE, DELOITTE_ALM_PROJECT, RENAME, SETTINGS, TRICENTIS_QTEST } from "src/app/common/constants/app.constants";
import { ITabConfig } from "src/app/common/interface/tab.interface";

export interface IToolDefectFieldConfig {
  isNonDeloitteTool: boolean;
  releaseLabel: string;
  cycleLabel: string;
  submittedDateLabel: string;
  submittedByLabel: string;
  requiredFields: string[];
  optionalFields: string[];
}

export const TOOL_DEFECT_FIELD_CONFIG: Record<string, IToolDefectFieldConfig> = {
  [DELOITTE_ALM_PROJECT]: {
    isNonDeloitteTool: false,
    releaseLabel: 'Release',
    cycleLabel: 'Cycle',
    submittedDateLabel: 'Detected on Date',
    submittedByLabel: 'Detected By',
    requiredFields: [],
    optionalFields: [],
  },
  [TRICENTIS_QTEST]: {
    isNonDeloitteTool: true,
    releaseLabel: 'Affected Release',
    cycleLabel: 'Detected In Cycle',
    submittedDateLabel: 'Submitted Date',
    submittedByLabel: 'Submitted By',
    requiredFields: [
      'summary',
      'description',
      'status',
      'severity',
      'priority',
      'type',
      'cause',
      'detectedDate',
      'detectedByTeam',
      'detectedBy',
      'release',
    ],
    optionalFields: ['resolution', 'cycle', 'assignedTeam'],
  },
};

export const PROJECT = "project"
export const DISABLED = "Disabled"
export const TEST_CASE_TAB = "Test Cases";
export const TEST_SCENARIO_TAB = "Test Scenarios";
export const ICONS = "Icons";
export const ACTIONS = "Actions";
export const ACTION = "Action";
export const OBJECT_TYPE = "Object Type";
export const WEB = "Web";
export const WINDOW = "Window";
export const TABLE_HEADERS_OPTIONS = ["Mandatory Flag", "Dynamic Flag", "Search Flag", "TestDataTemplate", "Continue on Fail"];
export const NON_REQUIRE_HEADERS = ["Object", "Execute", "Page/Section", "isSelected", "Parent Section", "Execution Sequence"]
export const TEAM = "Team";
export const IMPORT = "Import";
export const UI_PATH_INTEGRATION = "UiPath Integration";
export const AUTO_GENERATE_USING_GEN_AI = "Auto Generate using GenAI";
export const AUTO_SCHEDULE_USING_GEN_AI = "Auto Schedule using GenAI";

// Tools requiring isActive check from project settings — used in common-tool-config and tool-project-details
export const CONFIGURABLE_TOOLS = ['Controls'];
export const CONFIGURABLE_LLM = 'LLM'
export const TSG_NOT_FOUND_STRING =
  "To generate scenarios based on 'Risk or Weight Based', please ensure that scenarios using either 'Full Coverage' or 'Test L4 at least once' are generated first. The most recent option will apply.";
export const TSG_NOT_FOUND_CHECK = "TSG file do not exist";
export const DEFECT_CAUSE = "ALM_Defect_Cause"
export const DEFECT_TYPE = "ALM_Defect_Type"
export const DEFECT_STATUS = "ALM_Defect_Status"
export const DEFECT_PRIORITY = "ALM_Defect_Priority"
export const DEFECT_SEVERITY = "ALM_Defect_Severity"
export const ALM_INTEGRATION = "ALM Integration";
export const OUTPUT_GENERATED_USING_GENERATIVE_AI_TECHNOLOGY = "The output will be generated using Generative AI technology.";
export const TEST_EXECUTION_SUMMARY = 'Test Execution Summary';
export const RUN_DETAILS = 'Run Details'
export const SHORT_SNACK_BAR_DURATION = 2000;
export const LONG_SNACK_BAR_DURATION = 5000;
export const WEB_SEARCH = 'webSearch';

export const PROJECT_CARD_MENU = [
  {
    label: SETTINGS,
    value: SETTINGS.toLowerCase()
  }
]

export const RELEASES_CARD_MENU = [
  {
    label: ADD_CYCLE,
    value: ADD_CYCLE.toLowerCase()
  },
  {
    label: COPY,
    value: COPY.toLowerCase()
  },
  {
    label: RENAME,
    value: RENAME.toLowerCase()
  },
  {
    label: DELETE,
    value: DELETE.toLowerCase()
  }
];

export const TEST_CASE_TYPES = {
  INTEGRATION_TEST : 'Integration Test',
  UNIT_TEST : 'Unit Test',
}

export const SNACKBAR_MSG = {
  ADD_PROJECT_RELEASE: "Project Release added successfully",
  RENAME_PROJECT_RELEASE: "Project Release renamed successfully",
  DELETE_PROJECT_RELEASE: "Project Release deleted successfully",
  COPY_PROJECT_RELEASE: "Project Release copied successfully",
  PROJECT_CYCLE_ADDED: "Project Cycle added successfully",
  PROJECT_DICTIONARY_UPLOADED: "File uploaded successfully",
  UPLOAD_INITIATED: "Upload initiated successfully",
  PROJECT_DICTIONARY_UPLOADED_PARTIAL_FAILURE: "File uploaded successfully except for the Bots with incorrect BotId.",
  PROJECT_DICTIONARY_UPLOADED_PARTIAL_VALIDATION_FAILURE: "File uploaded successfully except for the Bots with validation issues.",
  PROJECT_DICTIONARY_UPLOADED_FAILED: "File upload failed due to incorrect BotId.",
  PROJECT_DICTIONARY_SAVED: "Project Dictionary saved successfully",
  PROJECT_DICTIONARY_COPIED: "Project Dictionary copied successfully",
  PROJECT_DICTIONARY_TRANSACTION_DELETE: "Bot deleted successfully",
  PROJECT_DICTIONARY_IMPORT: "Golden Bot Dictionary Imported successfully",
  PROJECT_DICTIONARY_TRANSACTION_CREATE: "Bot created successfully",
  PROJECT_DICTIONARY_TRANSACTION_RENAME: "Bot Renamed successfully",
  APPLICATION_VERSION_IMPORT_MAPPING: "Import mapping has been initiated successfully",
  TAXONOMY_CHANGED:"Taxonomy for the current project successfully saved as ",
  APPLICATION_VERSION_IMPORT_SUCCESS: "Test Cases have been imported from app version",
  ERROR_PROJECT_DICTIONARY_UPLOADED: "Error occurred while uploading file",
  ERROR_PROJECT_DICTIONARY_IMPORT: "Error occurred while importing data from Golden Bot Dictionary",
  ERROR_PROJECT_DICTIONARY_SAVED: "Error occurred while saving Project Dictionary",
  ERROR_PROJECT_DICTIONARY_RETRIEVE: "Error occurred while fetching Project Dictionary",
  ERROR_PROJECT_DICTIONARY_DOWNLOAD: "Error occurred while downloading Project Dictionary",
  ERROR_PROJECT_DICTIONARY_TRANSACTION_DELETE: "Error occurred while Deleting bot",
  ERROR_PROJECT_DICTIONARY_TRANSACTION_RETRIEVE: "Error occurred while retrieving bot",
  ERROR_PROJECT_DICTIONARY_TRANSACTION_CREATE: "Error occurred while creating bot",
  ERROR_PROJECT_DICTIONARY_TRANSACTION_UPDATE: "Error occurred while updating bot",
  ERROR_RELEASE_CYCLE_FIELD : "Please uncheck the Detected in Release or Detected in Cycle in ALM in order to get the defect created successfully in ALM.",
  ERROR_DEFECT_RESOLUTION_FIELD: "Defect Resolution Field is not configured in associated ALM Project. Please contact usdeliveryexcellencesupport@deloitte.com and raise a support request to configure this field for your ALM Project",
  ERROR_DEFECT_DETAILS_AUTO_GENERATE: "There was some issue fetching the details automatically for given Error Context. Please fill in the form manually.",
  ORCHESTRATOR_SETTINGS_SAVED: "Orchestrator Settings saved successfully",
  SELENIUM_SETTINGS_SAVED: "Selenium Settings saved successfully",
  TOSCA_SETTINGS_SAVED: "Tosca Cloud Settings saved successfully",
  ERROR_ORCHESTRATOR_SETTINGS_SAVED: "Error occurred while saving Orchestrator Settings",
  ERROR_SELENIUM_SETTINGS_SAVED: "Error occurred while saving Selenium Settings",
  ERROR_TOSCA_SETTINGS_SAVED: "Error occurred while saving Tosca Settings",
  ERROR_ORCHESTRATOR_SETTINGS_FETCH: "Error occurred while fetching Orchestrator Settings",
  APPLICATION_SETTINGS_SAVED: "Application under test Settings saved successfully",
  ERROR_APPLICATION_SETTINGS_SAVED: "Error occurred while saving Application under test Settings",
  ERROR_APPLICATION_SETTINGS_FETCH: "Error occurred while fetching Application under test Settings",
  SUCCESS_MESSAGE_EXPORT_CONFIRM: "Successfully Exported",
  ERROR_MESSAGE_FETCH_DATA: "Error occurred while fetching the data. Please refresh.",
  EXPORT_ALL: "All user stories have been exported successfully.",
  ERROR_TEST_CASE_MAPPING: "Error occurred while mapping test case.",
  ERROR_FILTER_AUTO_GENERATED_TEST_SCENARIO: "Error in filtering auto generated test scenarios.",
  ERROR_TEST_SUITE_SETTINGS_FETCH: "Error occurred while fetching Scheduler Data",
  TEST_SUITE_SCHEDULED_SUCCESSFULLY: "Test Suite Scheduled successfully",
  ERROR_TEST_SUITE_SCHEDULE: "Error occurred while Scheduling Test Suite",
  TEST_SUITE_COPIED_SUCCESSFULLY: "Test Suite Copied successfully",
  ERROR_TEST_SUITE_COPY: "Error occurred while copying Test Suite",
  TEST_SUITE_CHANGE_STATUS_SUCCESSFULLY: "Test Suite status changed successfully",
  ERROR_TEST_SUITE_CHANGE_STATUS: "Error occurred while changing Test Suite status",
  TEST_SUITE_SAVE_SUCCESSFULLY: "Test Suite saved successfully",
  ERROR_TEST_SUITE_SAVE: "Error occurred while saving Test Suite",
  TEST_SUITE_CREATE_SUCCESSFULLY: "Test Suite Created successfully",
  ERROR_TEST_SUITE_CREATED: "Error occurred while creating Test Suite",
  ERROR_PROJECTS: "Error occurred while getting Test Manager Projects",
  REDIRECTION_MSG: 'Please wait, you will be redirected to the appropriate URL location',
  ACCEPT_TERMS_SUCCESS: 'Generative AI Usage Policy Successfully enabled. Welcome to the project!',
  ACCEPT_TERMS_FAILURE: 'Generative AI Usage Policy was not enabled for the project.',
  ORCHESTRATOR_SETTINGS_DELETED: 'Tools settings reset successfully',
  ERROR_ORCHESTRATOR_SETTINGS_DELETED: 'Error occurred while resetting Tools settings'
}

export const TEST_CYCLE_SNACKBAR_MSG = {
  ADD_TEST_CYCLE: "Test cycle added successfully",
  UPDATE_TEST_CYCLE: "Test cycle updated successfully",
  DELETE_TEST_CYCLE: "Test cycle deleted successfully",
  UPDATE_TEST_CYCLE_ERROR: "Error in updating test cycle",
}

export const ALM_SNACKBAR_MSG = {
  ENABLED_INTEGRATION: "Deloitte ALM Project successfully enabled",
  DISABLED_INTEGRATION: "ALM integration successfully disabled"
}

export const QTEST_SNACKBAR_MSG = {
  ENABLED_INTEGRATION: "qTest integration successfully enabled",
  DISABLED_INTEGRATION: "qTest integration successfully disabled"
}

export const TOOL_SNACKBAR_MSG = {
  ENABLED_INTEGRATION: " integration successfully enabled",
  DISABLED_INTEGRATION: " integration successfully disabled"
}

export const TEAMS_CARD_MENU = [
  {
    label: ADD_TEAM_MEMBERS,
    value: ADD_TEAM_MEMBERS.toLowerCase()
  },
/*   {
    label: COPY,
    value: COPY.toLowerCase()
  }, */
  {
    label: RENAME,
    value: RENAME.toLowerCase()
  },
  {
    label: DELETE,
    value: DELETE.toLowerCase()
  }
];

export const MANAGE_TEAMS_SNACKBAR_MSG = {
  ADD_PROJECT_TEAM: "Project Team added successfully",
  RENAME_PROJECT_TEAM: "Project Team renamed successfully",
  DELETE_PROJECT_TEAM: "Project Team deleted successfully",
  COPY_PROJECT_TEAM: "Project Team copied successfully",
  ADD_TEAM_MEMBER: "Team Member(s) added successfully",
  ASSIGN_L3: "L3 Process assigned successfully",
};

export const ERROR_MSG = 'Oops! Something went wrong. Please try again.';
export const EMPTY_BOT_MSG = 'There is no bot for this Test Case. Please generate the bot.';
export const ASSIGN_TESTER = 'Assign tester for selected';
export const TEST_SCENARIO_CYCLE = "Test scenario cycle";
export const TEST_DATA_TYPES = ['Text', 'Number', 'Date'];
export const APP_FIELD_COLUMNS = ['applicationField', 'dataType', 'value'];
export const DETECTED_IN_CYCLE = "Detected in Cycle";
export const DETECTED_IN_RELEASE = "Detected in Release";
export const DEFECT_RESOLUTION_FIELD = "user-25";
export const SAVE_DISABLED_TOOLTIP = 'All mandatory fields need to be entered';
export const PROJECT_TRANSITION_MESSAGE = 'Project transition is in progress.';
export const PROJECT_DETAILS_PAGE_URL = 'projects/details';
export const LIBRARY_DETAILS_PAGE_URL = 'library/taxonomy-details/application-version-details';
export const NO_RECORDS_FOUND_MSG = 'No Records found';
export const NO_RECORDS_FOUND_TS_US_MSG = 'There are no records.';
export const NO_RECORDS_FOUND_DEFECT_TAB_MSG = 'There are no defects yet.';
export const COLUMNS_UNAVAILABLE_MSG = 'Some columns are currently unavailable. Customize columns in Tricentis qTest environment.';
export const VIEW_DETAILS = 'View details';
export const VIEW_DETAILS_POPUP_TITLE = 'Additional columns';
export const VIEW_DETAILS_POPUP_DESCRIPTION = 'You can optionally add custom fields in Tricentis qTest and the data will be reflected in qTest project:';
export const VIEW_DETAILS_POPUP_CANCEL_LABEL = 'Cancel';

export const USER_STORIES_VIEW_DETAILS_COLUMNS = [
  {
    fields: [
      'Universal Id',
      'Source',
      'Country',
      'Region',
      'Country Specificity',
      'Dev Object Id',
      'User Story Type',
      'User Story Id',
      'User Story Acceptance Criteria',
    ],
  },
];

export const DEFECTS_VIEW_DETAILS_COLUMNS = [
  {
    fields: [
      'Assigned team',
      'Detected by team',
      'Detected in cycle',
      'Resolution'
      
    ],
  },
];

export const TEST_SCENARIOS_VIEW_DETAILS_COLUMNS = [
  {
    sectionTitle: 'Test scenarios',
    fields: ['Type', 'Test scenario seq Id', 'Team name'],
  },
  {
    sectionTitle: 'Test case',
    fields: ['Team', 'Test case ID', 'Job profile', 'Security role', 'System', 'Screen', 'Test data'],
  },
  // {
  //   sectionTitle: 'App steps',
  //   fields: ['Controls'],
  // },
];
export const NO_RECORDS_FOUND_TEAM_DETAILS_TEAM_MEMBERS_MSG = 'No Team members to display.';
export const NO_RECORDS_FOUND_TEAM_DETAILS_TEAM_CALENDER_MSG = 'No data available.';
export const NO_RECORDS_FOUND_PROJECT_MANAGEMENT_MSG = 'No records found, please try to apply different filters or search.';
export const NO_RECORDS_FOUND_CYCLE_DETAILS_MSG = 'No test cycles to display.'
export const NO_RECORDS_FOUND_USER_MANAGEMENT_MSG = 'No records found, please search different user.'
export const LINKED_BOT = 'Bot is linked to Bot Dictionary';
export const MAP_BOT = 'Link Bot';
export const COPY_BOT = 'Copy Bot';

export const MAPPING_STATUS = {
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  PENDING: 'PENDING'
}

export const EXPORT_TOOLTIP_MESSAGES = {
  ORPHAN_TEST_CASES: 'Test Scenario contains missing Test Cases hence cannot be exported.',
  DATA_IN_PROGRESS: 'Data is being exported.',
  REQUIRED_RELEASE_CYCLE: 'Required release and cycle data.',
};

export const ROW_STATUS = {
  IN_PROGRESS: 'In Progress',
};

export const ADDED_BOT_TYPE = [
  {
    label: 'Copy Bot Items',
    value: 'copyBot',
    description:
      'Bot content will be added as a Copy of items. Items will not have dependencies on the Bot Dictionary. Editing of all items as independent objects will be available.',
  },
  {
    label: 'Link Bot',
    value: 'mapBot',
    description:
      'The bot will be added as a linked bot to the Bot Dictionary. After its updates in the Dictionary, the changes will be applied to the current Page/Section. Editing a linked bot is not possible.',
  },
];

export const CUSTOM_CODE_TAB_DETAILS: ITabConfig[] = [
    { label: "Enter Prompt" },
    {label: "Enter Code"},
]

export const CUSTOM_CODE_STATUS =[
  'Generated',
  'Success',
  'Failed'
]

export const CUSTOM_CODE_STATUS_MESSAGES = {
  'Generated': 'This output was created with the assistance of Generative AI technology',
  'Success': 'Validation passed. Feel free to submit the code.',
  'Failed': 'Validation failed. Review the code for mistakes.'
}

export const ASK_ME_USER = 'user';
export const ASK_ME_ASSISTANT = 'assistant';
export const ASK_ME_ERROR_MESSAGE = 'Error Generating Response, Please try again later.'
export const ASK_ME_WORKING_ON_RESPONSE = 'Working on response...';
export const ASK_ME_INPUT_PLACEHOLDER = 'Ask me anything regarding the Test AI functionality';

export const SPECIAL_CHARACTER_NOT_ALLOWED = "Name cannot contain only special characters.";
export const ALLOWED_SPECIAL_CHARACTERS = /^[^a-zA-Z0-9]*$/;
export const UPLOAD_CONSTANT = {
  inProgress: 'IN_PROGRESS',
  completed: 'COMPLETED',
  toDo: 'TO_DO',
  failed: 'FAILED'
}
export const SAVE_AUTO_GENERATED_TC = {
  key: 'Auto Generated',
  text:
    'test cases require your attention to save the scenario. Please delete or save them to a project.',
  save_btn: 'Save Auto Generated Test Cases to Project',
  remove_btn: 'Remove Auto Generated Test Cases',
};